import { render, staticRenderFns } from "./submenu.vue?vue&type=template&id=13290c34&scoped=true&"
import script from "./submenu.vue?vue&type=script&lang=js&"
export * from "./submenu.vue?vue&type=script&lang=js&"
import style0 from "./submenu.vue?vue&type=style&index=0&id=13290c34&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13290c34",
  null
  
)

export default component.exports